module.exports = __webpack_public_path__ + "static/umowa_o_prowadzenie_windykacji_en-ceef854834be8bc7c7ed44fbf0442461.pdf";